/* Feinkost Angelo - die Lupe: Klick auf ein Produktbild zeigt es bildschirmfuellend.
   Blaettern per Pfeil, Miniatur, Wischen und Pfeiltasten; Schliessen per X, Escape
   oder Klick daneben. Das Fenster wird erst beim ersten Oeffnen gebaut, und die
   Nachbarbilder werden im Hintergrund schon geholt - so blaettert es ohne Warten. */
(function () {
  'use strict';

  if (!document.body || !document.querySelector) return;

  var lupe = null, grossBild = null, zaehler = null, streifen = null, mitte = null;
  var liste = [], stelle = 0, fokusVorher = null;

  var PFEIL_LINKS = '<svg viewBox="0 0 11 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 1 2 9l7 8"/></svg>';
  var PFEIL_RECHTS = '<svg viewBox="0 0 11 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 1l7 8-7 8"/></svg>';
  var KREUZ = '<svg viewBox="0 0 15 15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M1 1l13 13M14 1L1 14"/></svg>';

  function bauen() {
    if (lupe) return;

    lupe = document.createElement('div');
    lupe.className = 'fa-lupe';
    lupe.setAttribute('role', 'dialog');
    lupe.setAttribute('aria-modal', 'true');
    lupe.setAttribute('aria-label', 'Bild vergrößert');
    lupe.innerHTML =
      '<div class="fa-lupe-kopf">' +
        '<span class="fa-lupe-zaehler"></span>' +
        '<button type="button" class="fa-lupe-zu" aria-label="Schließen">' + KREUZ + '</button>' +
      '</div>' +
      '<div class="fa-lupe-mitte">' +
        '<button type="button" class="fa-lupe-pfeil zurueck" aria-label="Vorheriges Bild">' + PFEIL_LINKS + '</button>' +
        '<img class="fa-lupe-bild" alt="">' +
        '<button type="button" class="fa-lupe-pfeil vor" aria-label="Nächstes Bild">' + PFEIL_RECHTS + '</button>' +
      '</div>' +
      '<div class="fa-lupe-streifen"></div>';

    document.body.appendChild(lupe);

    grossBild = lupe.querySelector('.fa-lupe-bild');
    zaehler = lupe.querySelector('.fa-lupe-zaehler');
    streifen = lupe.querySelector('.fa-lupe-streifen');
    mitte = lupe.querySelector('.fa-lupe-mitte');

    lupe.querySelector('.fa-lupe-zu').addEventListener('click', schliessen);
    lupe.querySelector('.fa-lupe-pfeil.zurueck').addEventListener('click', function () { zeige(stelle - 1); });
    lupe.querySelector('.fa-lupe-pfeil.vor').addEventListener('click', function () { zeige(stelle + 1); });

    /* Klick auf die freie Flaeche schliesst */
    lupe.addEventListener('click', function (e) {
      if (e.target === lupe || e.target === mitte) schliessen();
    });

    /* Wischen */
    var startX = null;
    mitte.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    mitte.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var weg = e.changedTouches[0].clientX - startX;
      if (Math.abs(weg) > 40) zeige(weg < 0 ? stelle + 1 : stelle - 1);
      startX = null;
    }, { passive: true });
  }

  /* Nachbarbilder im Hintergrund holen */
  function vorholen() {
    [stelle + 1, stelle - 1].forEach(function (k) {
      var nachbar = liste[(k + liste.length) % liste.length];
      if (!nachbar || nachbar.geholt) return;
      nachbar.geholt = true;
      var still = new Image();
      still.src = nachbar.gross;
    });
  }

  function zeige(n) {
    if (!liste.length) return;
    stelle = (n + liste.length) % liste.length;
    var eintrag = liste[stelle];
    eintrag.geholt = true;

    grossBild.classList.remove('da');
    var neu = new Image();
    function fertig() {
      grossBild.src = eintrag.gross;
      grossBild.alt = eintrag.alt || '';
      grossBild.classList.add('da');
      vorholen();
    }
    neu.onload = fertig;
    neu.onerror = fertig;
    neu.src = eintrag.gross;

    zaehler.textContent = (stelle + 1) + ' / ' + liste.length;
    Array.prototype.forEach.call(streifen.children, function (m, k) {
      m.classList.toggle('aktiv', k === stelle);
      m.setAttribute('aria-current', k === stelle ? 'true' : 'false');
    });

    var einzeln = liste.length < 2;
    lupe.querySelector('.fa-lupe-pfeil.zurueck').hidden = einzeln;
    lupe.querySelector('.fa-lupe-pfeil.vor').hidden = einzeln;
    streifen.hidden = einzeln;
    zaehler.hidden = einzeln;
  }

  function oeffnen(galerie, start) {
    bauen();

    liste = Array.prototype.map.call(galerie.querySelectorAll('[data-fa-schau]'), function (b) {
      return {
        gross: b.getAttribute('data-fa-gross') || b.currentSrc || b.src,
        klein: b.currentSrc || b.src,
        alt: b.getAttribute('alt'),
        geholt: false
      };
    });
    if (!liste.length) return;

    streifen.innerHTML = '';
    liste.forEach(function (eintrag, k) {
      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'fa-lupe-mini';
      knopf.setAttribute('aria-label', 'Bild ' + (k + 1) + ' von ' + liste.length + ' zeigen');
      var mini = document.createElement('img');
      mini.src = eintrag.klein;
      mini.alt = '';
      mini.loading = 'lazy';
      knopf.appendChild(mini);
      knopf.addEventListener('click', function () { zeige(k); });
      streifen.appendChild(knopf);
    });

    fokusVorher = document.activeElement;
    document.body.style.overflow = 'hidden';
    lupe.classList.add('offen');
    zeige(start || 0);
    lupe.querySelector('.fa-lupe-zu').focus();
  }

  function schliessen() {
    if (!lupe || !lupe.classList.contains('offen')) return;
    lupe.classList.remove('offen');
    document.body.style.overflow = '';
    if (fokusVorher && fokusVorher.focus) fokusVorher.focus();
    fokusVorher = null;
  }

  /* Aus einer Buehne heraus oeffnen - an der Stelle, die gerade zu sehen ist */
  function ausBuehne(buehne) {
    var galerie = buehne.closest('[data-fa-galerie]');
    if (!galerie) return;
    var bilder = galerie.querySelectorAll('[data-fa-schau]');
    var jetzt = 0;
    Array.prototype.forEach.call(bilder, function (b, k) {
      if (b.classList.contains('aktiv')) jetzt = k;
    });
    oeffnen(galerie, jetzt);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    /* Die Pfeile auf der Buehne blaettern nur - sie sollen nicht vergroessern */
    if (e.target.closest('.produkt-pfeil')) return;
    var buehne = e.target.closest('.fa .produkt-buehne');
    if (buehne) ausBuehne(buehne);
  });

  document.addEventListener('keydown', function (e) {
    /* Offene Lupe bedienen */
    if (lupe && lupe.classList.contains('offen')) {
      if (e.key === 'Escape') { e.preventDefault(); schliessen(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); zeige(stelle - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); zeige(stelle + 1); }
      return;
    }
    /* Mit der Tastatur oeffnen, wenn die Buehne den Fokus hat */
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var aktiv = document.activeElement;
    if (!aktiv || !aktiv.classList || !aktiv.classList.contains('produkt-buehne')) return;
    e.preventDefault();
    ausBuehne(aktiv);
  });
})();
